export const range = (start: number, end: number, step: number) => {
  if (step === 0) {
    return []
  }

  const arr: number[] = []

  if (step > 0) {
    for (let i = start; i <= end; i += step) {
      arr.push(i)
    }
  } else {
    for (let i = start; i >= end; i += step) {
      arr.push(i)
    }
  }

  return arr
}
